// ================================================================================
// wp-block-related-image-slider.js
// スライダーのスクリプトファイル
// ================================================================================

import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';


document.addEventListener('DOMContentLoaded', () => {

	const swiper = new Swiper('.js-related-slider-swiper', {
		modules: [Autoplay, Navigation, Pagination],
		loop: true,
		slidesPerView: 1,
		autoplay: {
			delay: 2500, // 4秒ごとに切り替え（お好みで調整可）
			disableOnInteraction: false, // ユーザー操作後も自動再開したい場合
		},
		speed: 1000,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},

	});

} );
